import { z } from 'zod';

export const ActivityUserSchema = z.object({
  displayName: z.string(),
});

export type ActivityUser = z.infer<typeof ActivityUserSchema>;
